import React from 'react';

import { Button } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';

import { Status } from '../../../types';
import { useIsAdministrator } from '../../../util/administratorMethods';

type OptionProps = {
  ideaStatus?: Status;
  handlePublish: (status: Status) => void;
};

const ReadyForFinals = ({ ideaStatus, handlePublish }: OptionProps) =>
  ideaStatus === 'doneHacking' ? (
    <Button
      onClick={async () => await handlePublish('readyForFinals')}
      startIcon={<PublishIcon />}
    >
      Ready for Finals
    </Button>
  ) : null;

const RevertReadyForJury = ({ ideaStatus, handlePublish }: OptionProps) =>
  ideaStatus === 'readyForJury' ? (
    <Button
      startIcon={<PublishIcon />}
      onClick={async () => await handlePublish('draft')}
    >
      Revert Ready for Jury
    </Button>
  ) : null;

const RevertDoneHacking = ({ ideaStatus, handlePublish }: OptionProps) =>
  ideaStatus === 'doneHacking' ? (
    <Button
      startIcon={<PublishIcon />}
      onClick={async () => handlePublish('readyForHacking')}
    >
      Revert Done Hacking
    </Button>
  ) : null;

const RevertReadyForFinals = ({ ideaStatus, handlePublish }: OptionProps) =>
  ideaStatus === 'readyForFinals' ? (
    <Button
      startIcon={<PublishIcon />}
      onClick={async () => handlePublish('doneHacking')}
    >
      Revert Ready for Finals
    </Button>
  ) : null;

const RestoreIdea = ({ ideaStatus, handlePublish }: OptionProps) =>
  ideaStatus === 'canceled' ? (
    <Button
      startIcon={<PublishIcon />}
      onClick={async () => handlePublish('draft')}
    >
      Restore Idea
    </Button>
  ) : null;

const RevertToDraft = ({ ideaStatus, handlePublish }: OptionProps) =>
  ideaStatus !== 'draft' &&
  ideaStatus !== 'canceled' &&
  ideaStatus !== undefined ? (
    <Button
      startIcon={<PublishIcon />}
      onClick={async () => handlePublish('draft')}
    >
      Revert to Draft
    </Button>
  ) : null;

export const AdminOptions = ({ ideaStatus, handlePublish }: OptionProps) => {
  const isAdministrator = useIsAdministrator();

  if (!isAdministrator) {
    return null;
  }

  return (
    <>
      <ReadyForFinals ideaStatus={ideaStatus} handlePublish={handlePublish} />
      <RevertToDraft ideaStatus={ideaStatus} handlePublish={handlePublish} />
      <RevertReadyForJury
        ideaStatus={ideaStatus}
        handlePublish={handlePublish}
      />
      <RevertDoneHacking
        ideaStatus={ideaStatus}
        handlePublish={handlePublish}
      />
      <RevertReadyForFinals
        ideaStatus={ideaStatus}
        handlePublish={handlePublish}
      />
      <RestoreIdea ideaStatus={ideaStatus} handlePublish={handlePublish} />
    </>
  );
};
